//@ts-nocheck
//@ts-ignore
/* eslint-disable */
import React, { useContext } from 'react';
import './styles.scss';
import { CheckContext } from './context';
import cn from 'classnames';
import { Typography } from '../../typography-voery/Typography';

interface OptionProps {
  children: React.ReactNode;
  value: string | number | boolean;
  className?: string;
}

export const Option: React.FC<OptionProps> = ({ children, value, className }) => {
  const { handleChange, currentValue } = useContext(CheckContext);
  const isActive = currentValue === value;

  return (
    <div
      className={cn('option', { active: isActive }, className)
      }
      onClick={() => handleChange(value)}
    >
      <Typography variant='body-semibold' className='option-text'>
        {children}
      </Typography>
    </div>
  );
};
